import PropTypes from 'prop-types';

const BaseballBases = ({ firstBase, secondBase, thirdBase }) => (
  <svg
    fill="none"
    height="16"
    style={{ aspectRatio: '16/12' }}
    viewBox="0 0 16 12"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Bases</title>
    <path
      clipRule="evenodd"
      d="M4.08377 5.38883C3.94393 5.24899 3.71547 5.25072 3.58257 5.38362L1.0481 7.91808C0.91114 8.05505 0.912904 8.27887 1.05332 8.41929L3.51675 10.8827C3.65659 11.0226 3.88505 11.0208 4.01795 10.8879L6.55242 8.35346C6.68938 8.2165 6.68762 7.99267 6.54721 7.85226L4.08377 5.38883Z"
      fillRule="evenodd"
      fill="#0079FFFF"
      style={{
        fill: thirdBase ? '#0079FFFF' : '#ddd',
      }}
    />
    <path
      clipRule="evenodd"
      d="M8.28373 1.10318C8.14388 0.96334 7.91542 0.965073 7.78252 1.09797L5.24806 3.63244C5.11109 3.7694 5.11286 3.99323 5.25327 4.13364L7.7167 6.59707C7.85654 6.73692 8.08501 6.73518 8.2179 6.60229L10.7524 4.06782C10.8893 3.93086 10.8876 3.70703 10.7472 3.56662L8.28373 1.10318Z"
      fillRule="evenodd"
      style={{
        fill: secondBase ? '#0079FFFF' : '#ddd',
      }}
    />
    <path
      clipRule="evenodd"
      d="M12.4837 5.38883C12.3438 5.24898 12.1154 5.25072 11.9825 5.38362L9.44801 7.91808C9.31104 8.05505 9.31281 8.27887 9.45322 8.41929L11.9167 10.8827C12.0565 11.0226 12.285 11.0208 12.4179 10.8879L14.9523 8.35346C15.0893 8.2165 15.0875 7.99267 14.9471 7.85226L12.4837 5.38883Z"
      fillRule="evenodd"
      style={{
        fill: firstBase ? '#0079FFFF' : '#ddd',
      }}
    />
  </svg>
);

BaseballBases.displayName = 'BaseballBases';

BaseballBases.propTypes = {
  firstBase: PropTypes.string,
  secondBase: PropTypes.string,
  thirdBase: PropTypes.string,
};

BaseballBases.defaultProps = {
  firstBase: null,
  secondBase: null,
  thirdBase: null,
};

export default BaseballBases;
